export enum MetaDataFrame {
	Name = 'Metadata Dataframe-',
}
